import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as integrationsDuck from '../../_augmentt/ducks/integrations'
import { getIntegrations, GWS, OFFICE365 } from '../crud/integration.crud'
import { getPreferredDirectoryIntegration } from '../pages/home/utils/integrations'

const useCustomerIntegration = ({ selectedCustomerId, defaultSelection = OFFICE365 }) => {
  const dispatch = useDispatch()
  const customerIntegration = useSelector(({ integrations }) => integrations.selectedIntegration)

  useEffect(() => {
    const getCustomerIntegrations = async () => {
      const result = await getIntegrations(selectedCustomerId)
      const fetchedIntegrations = result?.data ?? []
      const preference = [defaultSelection, GWS].filter((name, index, names) => names.indexOf(name) === index)
      const defaultIntegration = getPreferredDirectoryIntegration(fetchedIntegrations, preference, {
        customerId: selectedCustomerId,
      })

      dispatch(integrationsDuck.actions.setIntegrations(fetchedIntegrations))
      dispatch(integrationsDuck.actions.setSelectedIntegration(defaultIntegration ?? null))
    }

    if (selectedCustomerId) {
      getCustomerIntegrations()
    } else {
      dispatch(integrationsDuck.actions.setSelectedIntegration(null))
      dispatch(integrationsDuck.actions.setIntegrations([]))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCustomerId, defaultSelection, dispatch])

  return customerIntegration
}

export default useCustomerIntegration
